export const environment = {
  production: true,
  API_HOST: "https://stage.fitflop.letsflo.io/api",
  image_folder: "fitflop",
  heap: { enabled: true, appid: "169500035" },
  api_search_enabled: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts